<div class="footer-top-shad"></div>

<div class="footer">
	<div class="container-fluid">
		<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
		</div>
		<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
		</div>
		<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
		</div>
		<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
		</div>
	</div>
</div>


<div class="footer legal">
	<div class="container-fluid">
		<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 legal-section">
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-right powered-by-section">
			<ul class="list-inline"> 
			{{#if showPoweredByLink}}
				<li class="first-child powered-by"><a href="{{{poweredByLink}}}"> {{{JspPublicCodes_JSP_POWERED_BY}}} <img alt="bidlogix"
						src="/ms-gulphq/resources/dest{{contextPath}}/images/powered-by.png" width="77" height="18">
				</a></li>
			{{/if}}
			</ul>
		</div>
	</div>
</div>
